import { Box, Text, HStack, Card, VStack, Spinner } from '@chakra-ui/react';
import { Progress } from '@chakra-ui/react';
import { useGetTopSell } from '@/services/dashboard';

const TopSellingProgressBar = () => {
  const { data: topSellData, isLoading, isError } = useGetTopSell();

  return (
    <Card
      h={450}
      fontFamily={'primary'}
      borderColor={'border.default60'}
      p={4}
      shadow={0}
      borderWidth={'1px'}
      position={'relative'}
    >
      <Text fontSize="xl" fontWeight="semibold" mb={8}>
        Top Selling
      </Text>
      {isLoading ? (
        <VStack
          height="380px" // Adjusted for header height
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Spinner />
        </VStack>
      ) : isError ||
        !topSellData ||
        !topSellData.top_selling_products ||
        topSellData.top_selling_products.length === 0 ? (
        <VStack
          height="380px" // Adjusted for header height
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <VStack spacing={1}>
            <Text color="text.primary" fontSize="xl" fontWeight="semibold">
              No data available
            </Text>
            <Text color="text.disabled" fontSize="sm">
              There are no top-selling products to display.
            </Text>
          </VStack>
        </VStack>
      ) : (
        topSellData.top_selling_products
          .slice(0, 4) // Only take the first 4 products
          .map((product, index) => (
            <Box mb={6} key={index}>
              <Text fontSize="lg" fontWeight="semibold" mb={0}>
                {product.product_name}
              </Text>
              <HStack gap={5} alignItems="center">
                <Progress
                  width={'100%'}
                  size="lg"
                  value={product.percentage_contribution}
                  rounded={'lg'}
                  bg={'red.100'}
                  sx={{
                    '& > div': {
                      borderRadius: 'lg',
                      background: 'linear-gradient(to right, #FEA01A, #A71C29)',
                    },
                  }} // Add gradient background
                />
                <Text
                  fontSize={'2xl'}
                  fontWeight={'semibold'}
                  color={'#A71C29'}
                  mt={1}
                >{`${product.percentage_contribution}%`}</Text>
              </HStack>
            </Box>
          ))
      )}
    </Card>
  );
};

export default TopSellingProgressBar;
